<!--
* @Name：工程类认定申请审批
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="工程类认定申请审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">工程类认定申请</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="supplierInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">供应商信息</span>
        </template>
        <supplier-info
          :data-list="headInfo.suppDomainQualifyItemDtoList"
          :editable="reviewInfoEditable"
          @review-success="reviewSuccess"
        />
      </van-collapse-item>
      <van-collapse-item name="bankInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">银行信息</span>
        </template>
        <bank-info :data-list="headInfo.suppDomainQualifyBankList" />
      </van-collapse-item>
      <van-collapse-item name="templateInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">评审项模板</span>
        </template>
        <review-info :template-info="templateInfo" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval :page-context="thisPage" @get-process-info="onGetProcessInfo" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { supplierApplyBase, supplierApplyInfo } from '@/api/qualifyApply'
import Bridge from '@/components/dsbridge'
import { Dialog } from 'vant'
export default {
  name: 'QualifyApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'supplier-info': () => import('./components/SupplierInfo.vue'),
    'bank-info': () => import('./components/BankInfo'),
    'review-info': () => import('./components/ReviewTemplate')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'supplierInfo', 'bankInfo', 'templateInfo', 'approvalOpinions'],
      // 主单信息对象
      headInfo: {},
      // 附件列表
      attachList: [],
      // 评审项模板数据
      templateInfo: '',
      // 审批节点KEY
      taskDefinitionKey: ''
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 调用接口获取主单基本数据和附件信息
    async initData() {
      const headResp = await supplierApplyBase(this.$route.query.businessKey)
      this.headInfo = headResp.data
      const param = {
        purorgId: this.headInfo.purorgId,
        cooperationDomain: this.headInfo.cooperationDomain
      }
      const template = await supplierApplyInfo(param)
      this.templateInfo = template.data.reviewTemplate
    },
    // 返回到审批列表页
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    // 当前审批节点配置信息
    onGetProcessInfo(processInfo) {
      this.taskDefinitionKey = processInfo.taskDefKey
    },
    // 评审成功后刷新数据
    async reviewSuccess() {
      const headResp = await supplierApplyBase(this.$route.query.businessKey)
      this.headInfo = headResp.data
    }
  },
  computed: {
    // 会签节点时，可以进行评审
    reviewInfoEditable() {
      return this.taskDefinitionKey === 'Activity_1sjihnv'
    },
    thisPage() {
      return this
    }
  },
  bpmHooks: {
    async beforeHandler(type) {
      if (type === 'agree') {
        // 遍历供应商
        for (const item of this.headInfo.suppDomainQualifyItemDtoList) {
          // 遍历评审列表
          for (const reviewItem of item.suppDomainQualifyReviewList) {
            // 找到当前用户，判断是否已评审
            if (reviewItem.reviewerCode === this.$store.getters.username && reviewItem.conclusion === undefined) {
              await Dialog({ message: '请对供应商信息进行评审！' })
              this.$stopExecute()
              return
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
